import { useMemo } from "react";
import { CoinType } from "@onmo/graphql/graphql";
import { useAppSelector } from "../components/hooks";
import {
  CurrencyIcon,
  DEFAULT_WALLET_CONFIG,
  getCurrencyIcon,
  WalletConfig,
} from "../constants/wallet";

export const useWalletConfig = () => {
  const { theme } = useAppSelector((state) => state.theme);

  const walletConfig: WalletConfig = useMemo(() => {
    const raw = theme?.wallet;
    if (!raw?.primaryCurrency) return DEFAULT_WALLET_CONFIG;
    return {
      primaryCurrency: {
        base: raw.primaryCurrency.base as CoinType,
        spendable: raw.primaryCurrency.spendable as CoinType,
      },
      secondaryCurrencies: (raw.secondaryCurrencies || []) as CoinType[],
    };
  }, [theme?.wallet]);

  const isCurrencyEnabled = (coinType: CoinType): boolean => {
    const { primaryCurrency, secondaryCurrencies } = walletConfig;
    return (
      primaryCurrency.base === coinType ||
      primaryCurrency.spendable === coinType ||
      secondaryCurrencies.includes(coinType)
    );
  };

  const primaryIcon: CurrencyIcon = useMemo(
    () => getCurrencyIcon(walletConfig.primaryCurrency.base),
    [walletConfig.primaryCurrency.base],
  );

  const spendableIcon: CurrencyIcon = useMemo(
    () => getCurrencyIcon(walletConfig.primaryCurrency.spendable),
    [walletConfig.primaryCurrency.spendable],
  );

  return {
    walletConfig,
    isCurrencyEnabled,
    primaryIcon,
    spendableIcon,
    getCurrencyIcon,
  };
};
